import React from "react";
import { Modal } from "antd";

const RuleModal = ({ isVisible, onClose, rule }) => {
  return (
    <Modal title="Rule Details" open={isVisible} onOk={onClose} onCancel={onClose} footer={null}>
      <p style={{ whiteSpace: "pre-wrap" }}>{rule}</p>
    </Modal>
  );
};

export default RuleModal;
